var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 23",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5573 18.9391L17 21H19.5L5.5 1H3L4.81617 3.59453C4.37766 3.81815 3.96955 4.10842 3.60539 4.47258C2.55843 5.51955 2 7.05167 2 8.99219C2 11.7665 3.67833 14.3464 5.59069 16.3554C7.52781 18.3904 9.86887 20.1252 11.5394 20.9922H12.4606C13.3555 20.5278 14.4428 19.8143 15.5573 18.9391ZM14.4182 17.3117L5.98197 5.25996C5.60915 5.40946 5.28655 5.61985 5.01961 5.88679C4.44157 6.46483 4 7.43271 4 8.99219C4 10.9879 5.24167 13.088 7.03931 14.9765C8.63682 16.6547 10.5478 18.1704 12 18.9922C12.7239 18.5825 13.5619 18.0004 14.4182 17.3117Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "ill-rule": "evenodd",
    d: "M18.4093 16.3554C18.283 16.4881 18.1549 16.6196 18.0255 16.7496L16.8591 15.0826C16.8931 15.0473 16.927 15.0119 16.9607 14.9765C18.7583 13.088 20 10.9879 20 8.99219C20 7.43271 19.5584 6.46483 18.9804 5.88679C18.3989 5.30533 17.5534 4.99219 16.5 4.99219C14.6772 4.99219 13.5 6.49219 13 8.49219L12.2468 8.49074L8.45713 3.07468C10.06 3.36024 11.2287 4.3606 11.9999 5.6588C12.9116 4.11672 14.3814 2.99219 16.5 2.99219C17.9466 2.99219 19.3511 3.42905 20.3946 4.47258C21.4416 5.51955 22 7.05167 22 8.99219C22 11.7665 20.3217 14.3464 18.4093 16.3554Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.e79373ae7fbee9ac6c350349cd00a7b5.svg";
export { ForwardRef as ReactComponent };